import React from 'react';

interface ListItemProps {
  title: string;
  subtitle?: string;
  onClick?: () => void;
  isActive?: boolean;
  icon?: React.ReactNode;
}

const ListItem: React.FC<ListItemProps> = ({ title, subtitle, onClick, isActive = false, icon }) => {
  return (
    <li
      className={`p-4 rounded-lg cursor-pointer transition duration-150 ease-in-out transform hover:scale-105 ${
        isActive ? 'bg-blue-100 shadow-md' : 'bg-white shadow hover:shadow-md'
      }`}
      onClick={onClick}
    >
      <div className="flex items-center justify-between">
        <div>
          <h3 className={`font-semibold ${isActive ? 'text-blue-800' : 'text-blue-600'}`}>{title}</h3>
          {subtitle && <p className="text-sm text-blue-500">{subtitle}</p>}
        </div>
        {icon && <div className="ml-2">{icon}</div>}
      </div>
    </li>
  );
};

export default ListItem;